export type MarkupAvailability = { enabled: true } | { enabled: false; reason: string };

export interface MarkupAvailabilityInput {
    dmId: number | null;
    scansLoading: boolean;
    scanCount: number;
    scansFailed: boolean;
}

export const NOT_LINKED_REASON = 'Patient is not linked to Dental Monitoring';
export const LOADING_REASON = 'Loading scans…';
export const NO_SCANS_REASON = 'No Dental Monitoring scans yet';

// A failed list still opens the picker, which shows the error and a retry.
export function markupAvailability({
    dmId,
    scansLoading,
    scanCount,
    scansFailed
}: MarkupAvailabilityInput): MarkupAvailability {
    if (dmId == null) return { enabled: false, reason: NOT_LINKED_REASON };
    if (scansFailed) return { enabled: true };
    if (scansLoading) return { enabled: false, reason: LOADING_REASON };
    if (scanCount === 0) return { enabled: false, reason: NO_SCANS_REASON };
    return { enabled: true };
}
